import { Component, Input, OnInit, Output,EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { parsePhoneNumberFromString, isValidNumber, CountryCode, parsePhoneNumber } from 'libphonenumber-js';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-country-code',
    templateUrl: './country-code.component.html',
    styleUrls: ['./country-code.component.scss'],
    standalone: false
})
export class CountryCodeComponent implements OnInit, OnDestroy {
  @Input() stylechanged: any;
  @Input() countryIpData: any;
  @Input() country_code: FormControl;
  @Input() mobile_number: FormControl;
  @Input() countryListArr: any[];
  @Output() mobileNumberValidate: EventEmitter<boolean> = new EventEmitter();
  @Output() countryCodeVal: EventEmitter<CountryCode> = new EventEmitter();
  @ViewChild('countryselect') input: ElementRef;
  mobileNumber: string;
  public codeFilterCtrl: FormControl = new FormControl();
  countryForm: FormGroup ;
  newcountryCodedata = [];
  countryCode: CountryCode = 'CA';
  inValidMobileNumber: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject();

  ngOnInit(): void {
 
    if (this.countryIpData?.country_code) {
          this.countryCode = this.countryIpData?.country_code;
          this.countryCodeVal.emit(this.countryCode);
    }

    this.newcountryCodedata =  this.countryListArr;
    
    this.codeFilterCtrl.valueChanges
    .pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.getcodenumber();
    });

    this.mobileNumberChange();
  
  }


  mobileNumberChange() {
    this.mobile_number.valueChanges.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(val => { 
        this.inValidMobileNumber = false;       
        if (val && this.countryCode) {
           this.mobileNumberValidation();
        } else {
          this.inValidMobileNumber = false;
          this.mobileNumberValidate.emit(this.inValidMobileNumber);
        } 
        this.mobileNumberValidate.emit(this.inValidMobileNumber); 
      });
     
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
  selectClick(){    
    this.input.nativeElement.value = '';
    this.input.nativeElement.focus();
  }

    getcodenumber() {
      let keyvalue:string = this.codeFilterCtrl.value?.trim();
      if(keyvalue !=''){
      this.search(keyvalue);
      }else{
        this.newcountryCodedata = this.countryListArr;
      }
  }
    search(value: string) {
        let filter = value?.toLowerCase();        
        this.newcountryCodedata = this.countryListArr.filter(option => option.name?.toLowerCase().startsWith(filter) || option.phone_code.startsWith(filter));
    }

    getcode(val){
      this.newcountryCodedata = this.countryListArr;
      this.countryCode = this.countryListArr.find(c => c.id == val)?.country_code;
      this.countryCodeVal.emit(this.countryCode);
      if (this.countryCode && this.mobile_number?.value) {        
        this.mobileNumberValidation();
      } else {
        this.inValidMobileNumber = false;
        this.mobileNumberValidate.emit(false);
      }
    }

    getmobileNumber(val){
      console.log(this.country_code, val);
      if (val) {
        let phoneNumber: any = parsePhoneNumberFromString(val, (this.countryIpData?.country_code || 'CA') as CountryCode);
        console.log(phoneNumber?.formatNational());
        this.mobileNumber = phoneNumber?.formatNational();
      }
    }



    mobileNumberValidation() {
      if (!this.mobile_number?.value) {
        this.inValidMobileNumber = false;
        this.mobileNumberValidate.emit(false);
        return;
      }
      let phoneNumber: any = parsePhoneNumberFromString(this.mobile_number.value, (this.countryCode || 'CA') as CountryCode);
      const valid = isValidNumber(this.mobile_number.value, (this.countryCode || 'CA') as CountryCode);
      if (
        this.countryCode &&
        valid &&
        phoneNumber?.formatNational()
      ) {
        const formattedNumber = phoneNumber?.formatNational();
        this.mobile_number.patchValue(formattedNumber, { emitEvent: false });
        this.inValidMobileNumber = false;
      } else {
        this.inValidMobileNumber = true;
      }
      this.mobileNumberValidate.emit(this.inValidMobileNumber);
    }
}
